<template>
  <div>
    <div class="col-12 px-0">
      <label for="answer">Respuesta</label>
    </div>
    
    <div v-if="showRadios" class="d-flex">
      <div class="form-check me-3">
        <input 
          v-model="value" 
          type="radio" 
          class="form-check-input" 
          id="answer-true" 
          value="true" 
          required
          @input="checkTrue"
        >
        <label for="answer-true">
          <small>Verdadero</small>
        </label>
      </div>

      <div class="form-check">
        <input 
          v-model="value"
          type="radio" 
          class="form-check-input" 
          id="answer-false" 
          value="false" 
          required
          @input="checkFalse"
        >
        <label for="answer-false">
          <small>
            Falso
          </small>
        </label>  
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'BooleanQuestion',
  
  props: {
    question: {
      type: Object,
      required: true
    }
  },
  
  data() {
    return {
      modelQuestion: this.question,
      value: null
    }
  },

  computed: {
      showRadios() {
        return this.modelQuestion.options.length !== 0
      }

  },

  mounted() {
    if (this.modelQuestion.options.length === 0) {
      this.modelQuestion.options = [
        {label: 'Verdadero', isCorrect: false},
        {label: 'Falso', isCorrect: false}
      ]
    } else {
      if (this.modelQuestion.options[0].isCorrect === true ) {
        this.value = 'true'
        return
      }

      if (this.modelQuestion.options[1].isCorrect === true) {
        this.value = 'false'
      }
    }
  },

  methods: {
    checkTrue() {
      this.modelQuestion.options[0].isCorrect = true
      this.modelQuestion.options[1].isCorrect = false
    },

    checkFalse() {
      this.modelQuestion.options[0].isCorrect = false
      this.modelQuestion.options[1].isCorrect = true
    }
  },

  watch: {
    modelQuestion: {
      handler(newValue) {
        this.$emit('input', newValue)
      },
      deep: true
    }
  }
}
</script>